import {
  type Backend,
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import type { ServiceOfferingShopCategoryServicesCollection } from './service-offering-shop-category-services.types';

export function serviceOfferingShopCategoryServicesBackend(): Backend<ServiceOfferingShopCategoryServicesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (_authUid, ids, query, _order) => {
      const shopId = getQueryParamValue(query, 'shopId')[0];
      const categoryId = getQueryParamValue(query, 'categoryId')[0];
      if (ids && ids.length === 1) {
        return {
          endpoint: `service_offerings/0.1/service_offerings/shops/${shopId}/categories/${categoryId}/services/${ids[0]}`,
          params: {
            ids,
            limit: query?.searchQueryParams.limit,
            offset: query?.searchQueryParams.offset,
          },
        };
      }
      return {
        endpoint: `service_offerings/0.1/service_offerings/shops/${shopId}/categories/${categoryId}/services/`,
        params: {
          ids,
          limit: query?.searchQueryParams.limit,
          offset: query?.searchQueryParams.offset,
        },
      };
    },
    push: (_authUid, categoryServiceData) => {
      return {
        endpoint: `service_offerings/0.1/service_offerings/shops/${categoryServiceData.shopId}/categories/${categoryServiceData.categoryId}/services/`,
        method: 'POST',
        payload: {
          category_service: {
            service_offering_id: categoryServiceData.serviceOfferingId,
            category_id: categoryServiceData.categoryId,
          },
        },
      };
    },
    remove: (authUid, id, originalDocument) => {
      const dummyShopId = 0; // dummy shop Id being used to satisfy API endpoint; API only uses the category service Id.
      return {
        endpoint: `service_offerings/0.1/service_offerings/shops/${dummyShopId}/categories/${originalDocument.categoryId}/services/${originalDocument.id}`,
        method: 'DELETE',
        payload: {},
      };
    },
    set: undefined,
    update: undefined,
  };
}
